module.exports = __webpack_public_path__ + "img/25_39.b4c7fa55.png";